<div class="container-fluid">
    <div class="row">

      <div class="card shadow-sm p-0">
        <div class="card-header">
          <h3 class="card-title">{{ jurisdictionId ? 'Update Jurisdiction' : 'Create Jurisdiction' }} </h3>
        </div>
        <div class="card-body">
          <jurisdiction-form
            [jurisdiction]="jurisdiction"
            (onSavedData)="onJurisdictionFormSavedData($event)"
          />
        </div>
      </div>
    </div>
    
  </div>